<template>
  <div class="app">
    <div class="d-flex h-100 justify-content-center align-items-center">
      <div class="mx-auto app-login-box col-md-8">
        <div class="mb-3 d-flex align-items-center justify-content-center">
          <img v-show="temLogoClienteNaSessao" :src="logoCliente" alt="" width="200" class="tenant-logo brand-image mt-1 ml-3 mr-3"/>
          <img alt="logo" :src="obterLogo" width="200" class="office-logo brand-image img-fluid">
        </div>
        <div class="modal-dialog w-100 mx-auto">
          <div class="modal-content">
            <div class="modal-body">
              <div class="h5 modal-title text-center">
                <h4 class="mt-2">
                  <div>Bem vindo,</div>
                  <span>Por favor entre com seus dados abaixo.</span>
                  <div class="avisoDanger mensagemAlerta">{{mensagemAlerta}}</div>
                  <div v-if="flags.efetuandoLogin" class="divLoginSpinner mb-3">
                    <span class="avisoDanger">Por favor, aguarde...</span>
                    <b-spinner class="ml-2" variant="danger"></b-spinner>
                  </div>
                </h4>
              </div>
              <form v-if="flags.telaPronta">
                <div v-show="flags.escritorioNaoLogado" class="input-group mb-3">
                  <input type="text" @keyup="eventoEscritorioTeclaEnter" @blur="eventoSairDoCampoEscritorio" autocomplete="organization" name="escritorio" id="escritorio" class="form-control campoSemBordaDireita corBordaCampo placeholder" v-model="dadosFormulario.escritorio" placeholder="Escritório...">
                  <div class="input-group-append">
                    <div class="input-group-text fundoBotaoIcone corBordaCampo">
                      <i class="fa fa-layer-group fa-cor"></i>
                    </div>
                  </div>
                </div>
                <div v-show="flags.escritorioNaoLogado" class="avisoDanger text-left mb-2">{{erroValidacaoCampos.escritorio}}</div>

                <div class="input-group mb-3">
                  <input type="text" @keyup="eventoLoginTeclaEnter" :disabled="camposSenhaBloqueados" autocomplete="username" name="usuario" id="usuario" class="form-control campoSemBordaDireita corBordaCampo placeholder" v-model="dadosFormulario.usuario" placeholder="Usuário...">
                  <div class="input-group-append">
                    <div class="input-group-text fundoBotaoIcone corBordaCampo">
                      <i class="fa fa-user fa-cor"></i>
                    </div>
                  </div>
                </div>
                <div class="avisoDanger text-left mb-2">{{erroValidacaoCampos.usuario}}</div>
                <div v-if="exibirCampoSenha" class="input-group mb-3">
                  <input type="password" @keyup="eventoLoginTeclaEnter" :disabled="camposSenhaBloqueados" name="senha" id="senha" autocomplete="current-password" class="form-control campoSemBordaDireita corBordaCampo placeholder" v-model="dadosFormulario.senha" placeholder="Senha...">
                  <div class="input-group-append">
                    <div class="input-group-text fundoBotaoIcone corBordaCampo">
                      <i class="fa fa-lock fa-cor"></i>
                    </div>
                  </div>
                </div>
                <div v-if="exibirCampoSenha" class="avisoDanger text-left mb-2">{{erroValidacaoCampos.senha}}</div>
                <div id="acesso" class="mt-2">
                  <b-button variant="btn btn-secondary btn-sm botaoLogin" :disabled="flags.efetuandoLogin || !camposAcessoPreenchidos" @click="autenticar">Acessar Sistema</b-button>
                  <a href="#" class="linkOutroEscritorio textos" v-show="mostrarBotaoOutroEscritorio" :disabled="flags.efetuandoLogin" @click="acessarComOutroEscritorio">Acessar com outro escritório</a>
                  <router-link v-show="exibirCampoSenha && !camposSenhaBloqueados" class="linkOutroEscritorio textos" :to="{name: 'recuperar-senha-office'}" :disabled="flags.efetuandoLogin">Esqueci minha senha</router-link>
                </div>

                <div v-if="modoAutenticacao.ssoDisponivel" class="sso-divider">
                  <span class="sso-divider__line"></span>
                  <span class="sso-divider__text">ou continue com</span>
                  <span class="sso-divider__line"></span>
                </div>

                <div v-if="modoAutenticacao.ssoDisponivel" id="acesso-sso" class="mt-2 mb-3" :title="tituloBotaoSso">
                  <b-button variant="btn btn-secondary btn-sm botaoLogin botaoSso" :disabled="flags.efetuandoLogin || !modoAutenticacao.ssoDisponivel" @click="entrarComProvedorSso">
                    <img :src="iconePreambulo" alt="" class="icone-sso">
                    Entrar com Preâmbulo
                  </b-button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Login from './js'
export default Login
</script>

<style scoped>
@import "./scss/login.scss";
</style>
